<template>
  <div class="sg-transfer-panel" :style="panelStyle">
    <p class="sg-transfer-panel__header">
      <sg-checkbox
        v-model="allChecked"
        :indeterminate="isIndeterminate"
        :validate-event="false"
        @on-change="handleAllCheckedChange"
      >
        {{ title }}
        <span>{{ checkedLength }}项</span>
      </sg-checkbox>
    </p>

    <div
      :class="['sg-transfer-panel__body']"
      :style="bodyStyle"
    >
      <sg-input
        v-if="filterable"
        v-model="query"
        class="sg-transfer-panel__filter"
        size="default"
        :placeholder="'请输入搜索内容'"
        :prefix-icon="SearchIcon"
        clearable
        :validate-event="false"
        @mouseenter="inputHover = true"
        @mouseleave="inputHover = false"
        @on-input="handelInput"
        @on-clear="handelClear"
      >
      </sg-input>
      <sg-checkbox-group
        v-show="!hasNoMatch && data.length > 0"
        v-model="checked"
        :class="{ 'is-filterable': filterable }"
        class="sg-transfer-panel__list"
        :style="listStyle"
        :validate-event="false"
      >
        <sg-checkbox
          v-for="item in filteredData"
          :key="item[keyProp]"
          class="sg-transfer-panel__item"
          :label="item[keyProp]"
          :disabled="item[disabledProp]"
          :validate-event="false"
        >
          <option-content :option="optionRender!(item)" />
        </sg-checkbox>
      </sg-checkbox-group>
      <p
        v-show="hasNoMatch || data.length === 0"
        class="sg-transfer-panel__empty"
      >
        {{ hasNoMatch ? t('sg.transfer.noMatch') : noData }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, toRefs } from 'vue'
import { useLocale } from '@sgui-plus/hooks'
import { SgCheckbox, SgCheckboxGroup } from '@sgui-plus/components/checkbox'
import SgInput from '@sgui-plus/components/input'
import { Search } from '@sgui-plus/icons-vue'
import { useCheck, useCheckProps, CHECKED_CHANGE_EVENT } from './useCheck'

export default defineComponent({
  name: 'SgTransferPanel',

  components: {
    SgCheckboxGroup,
    SgCheckbox,
    SgInput,
    OptionContent: ({ option }) => option,
  },

  props: useCheckProps,

  emits: [CHECKED_CHANGE_EVENT, 'on-input', 'on-clear'],

  setup(props, { slots }) {
    const { t } = useLocale()

    const panelState = reactive({
      checked: [],
      allChecked: false,
      query: '',
      inputHover: false,
      checkChangeByUser: true,
    })

    const {
      labelProp,
      keyProp,
      disabledProp,
      filteredData,
      isIndeterminate,
      checkedLength,
      handleAllCheckedChange,
      handelInput,
      handelClear,
      panelStyle,
      bodyStyle,
      listStyle,
    } = useCheck(props, panelState)
    const hasNoMatch = computed(() => {
      return panelState.query.length > 0 && filteredData.value.length === 0
    })

    const noData = computed(() => {
      return props.noDataText ? props.noDataText : t('sg.transfer.noData')
    })


    const { checked, allChecked, query, inputHover, checkChangeByUser } =
      toRefs(panelState)

    return {
      labelProp,
      keyProp,
      disabledProp,
      filteredData,
      isIndeterminate,
      handleAllCheckedChange,
      checkedLength,
      checked,
      allChecked,
      query,
      inputHover,
      checkChangeByUser,

      hasNoMatch,
      noData,
      SearchIcon: Search,
      panelStyle,
      bodyStyle,
      listStyle,

      handelInput,
      handelClear,

      t,
    }
  },
})
</script>
